import { HELPER } from '@cms/tpl';
import { API_PATHS } from 'common';
const API = API_PATHS.MEDIA_REVENUE;
const Service = {
  getTotal: (params) => HELPER.API.executeGet(`${API.GET.TOTAL}${params}`),
};
export default Service;
